import { Injectable, signal } from '@angular/core';
import { OtaOverlayMode, OtaUpdateService } from './ota-update.service';

@Injectable()
export class WebOtaUpdateService extends OtaUpdateService {
  readonly mode = signal<OtaOverlayMode>('hidden').asReadonly();
  readonly isFadingOut = signal(false).asReadonly();
  readonly downloadPercent = signal(0).asReadonly();

  init(): void {}
}
